<template>
    <b-modal
        :id="modalId"
        :visible="show"
        @hidden="hideEvents"
        title="User Details"
        scrollable
    >
        <vue-element-loading :active="loading"></vue-element-loading>
        <r-form
            ref="form"
            :showHeader="false"
            :column-size="1"
            :disabled.sync="disabled"
            v-model="form"
            :validators="validators"
            :crud="true"
            @submit="saveUser"
            title="User Details"
            :show-footer="false"
        >
        </r-form>
        <template slot="modal-footer">
            <template v-if="disabled">
                <b-button
                        @click="hideModal"
                        variant="outline-secondary">
                    Cancel
                    <font-awesome-icon
                            :icon="['far', 'times']">
                    </font-awesome-icon>
                </b-button>

                <b-button
                      class="btn-arrow ml-auto"
                      variant="primary"
                      @click="disabled = false"
                >
                    Edit User
                    <font-awesome-icon
                            :icon="['far', 'arrow-right']">
                    </font-awesome-icon>
                </b-button>
            </template>
            <template v-else>
                <b-button
                        @click="$refs.form.onCancel()"
                        variant="outline-secondary"
                >
                    Cancel
                    <font-awesome-icon
                            :icon="['far', 'times']"
                    ></font-awesome-icon>
                </b-button>
                <b-button
                      @click="$refs.form.onSubmit()"
                      class="btn-arrow"
                      variant="primary"
                >
                    Save changes
                    <font-awesome-icon
                            :icon="['far', 'arrow-right']"
                    ></font-awesome-icon>
                </b-button>
            </template>
        </template>
    </b-modal>
</template>

<script>
import ModalMixin from '@/components/Modal/ModalMixin';
import RForm from '@/components/Form/RiskhubForm';
import User from '@/services/User/User';
import { forEach } from 'lodash';
import {
  form as UserForm,
  validators as UserValidators,
} from '@/services/User/UserForm';

export default {
  name: 'User-Item',
  components: {
    RForm,
  },
  mixins: [ModalMixin],
  props: {
    userId: {},
  },
  data() {
    return {
      disabled: true,
      loading: false,
      form: null,
      modalId: 'showUserModal',
      validators: UserValidators,
    };
  },
  watch: {
    userId: {
      handler(newUserId) {
        if (!newUserId) {
          return;
        }

        this.fetchUser(newUserId);
      },
      immediate: true,
    },
  },
  methods: {
    async fetchUser(userId) {
      this.loading = true;

      try {
        const { data } = await User.find(userId);
        const { user } = data;

        const allTeams = await User.getAvailableTeams();

        const form = UserForm();

        forEach(user, (value, key) => {
          if (key in form) {
            form[key].value = value;
          }
        });

        const userTeams = [];
        const userTeamIds = user.teams.map(team => team.teamId);

        userTeamIds.forEach((id) => {
          const arr = allTeams.filter(team => team.teamId === id);
          userTeams.push(arr[0]);
        });

        form.teams.options = allTeams;
        form.teams.value = userTeams;

        this.form = form;
      } finally {
        this.loading = false;
      }
    },
    async saveUser(form) {
      this.loading = true;

      const params = {};
      forEach(form, (object, field) => {
        params[field] = object.value;
      });

      params.teamIds = form.teams.value.map(team => team.teamId);

      try {
        const { data } = await User.update(this.userId, params);
        this.$notify({
          title: 'User updated',
          message: 'User has been successfully updated',
          type: 'success',
        });

        this.disabled = true;

        this.$emit('save');
      } finally {
        this.loading = false;
      }
    },
    hideModalEvents() {
      this.disabled = true;
      this.form = null;
    },
  },
};
</script>
